import { useCallback, useState } from 'react';
import UIFormControl from 'UIComponents/form/UIFormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIToggle from 'UIComponents/input/UIToggle';
import DateAndTimeSelect from 'automation-ui-canvas/components/settings/DateAndTimeSelect';
import UIFlex from 'UIComponents/layout/UIFlex';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScheduledDisableAtSetting = ({
  settings: {
    scheduledDisableAt
  },
  readOnly,
  onChange
}) => {
  const trackEvent = useTrackEvent();
  const scheduledDisableAtValue = scheduledDisableAt && scheduledDisableAt.value || null;
  const [isToggled, setIsToggled] = useState(!!scheduledDisableAtValue);
  const handleOnChange = useCallback(value => {
    trackEvent(Trackables.WORKFLOW_SETTINGS_INTERACTION, {
      value: `${value}`,
      subAction: 'disableAt'
    });
    onChange({
      scheduledDisableAt: {
        value
      }
    });
  }, [onChange, trackEvent]);
  const handleToggleChange = useCallback(({
    target: {
      checked
    }
  }) => {
    setIsToggled(checked);
    handleOnChange(checked ? scheduledDisableAtValue : null);
  }, [scheduledDisableAtValue, handleOnChange]);
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(UIFlex, {
      justify: "between",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformSettings.scheduledDisableAt.label"
      })
    }),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "m-bottom-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformSettings.scheduledDisableAt.help"
        })
      }), /*#__PURE__*/_jsx(UIToggle, {
        checked: isToggled,
        readOnly: readOnly,
        onChange: handleToggleChange
      }), isToggled && /*#__PURE__*/_jsx(DateAndTimeSelect, {
        onChange: handleOnChange,
        value: scheduledDisableAtValue,
        readOnly: readOnly || false
      })]
    })
  });
};
export default ScheduledDisableAtSetting;